import { GtmService } from '~/src/services/web-analytics.service';
import { getAnalyticsEventData } from '~/src/helpers/web-analytics-events-data.helper';
import { transliterate } from '~/src/helpers/transliterate.helper';
import {
    WebAnalyticsActionGroupEnum,
    WebAnalyticsEventActionEnum,
    WebAnalyticsEventCategoryEnum,
    WebAnalyticsEventEnum,
} from '~/src/models/enums/web-analytics.enum';

export const onSendProductClickAnalytics = (name: string, sefUrl: string, isOneProduct: boolean) => {
    GtmService.send(
        getAnalyticsEventData({
            eventAction: WebAnalyticsEventActionEnum.elementClick,
            eventLabel: transliterate(name),
            eventContent: isOneProduct ? transliterate(sefUrl) : null,
            event: WebAnalyticsEventEnum.vntEvent,
            eventCategory: WebAnalyticsEventCategoryEnum.agencyProducts,
            actionGroup: WebAnalyticsActionGroupEnum.interactions,
            productName: isOneProduct ? null : transliterate(sefUrl),
        }),
    );
};
